//
// ReportAssetURL.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../TransportModel";
import "./ReportAssetURLType";

var ReportAssetURL = createModule("transport::ReportAssetURL", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        contentKey: 7,
        name: 7,
        urlString: 7,
        usageVersion: 7,
        serverFile: 7,
        source: 7,
        type: 4,
        acceptType: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ReportAssetURL;
